export class VolunteerTagModel implements IVolunteerTagModel {
  tag?: string | undefined;
  dateAdded?: string | undefined;

  constructor(data?: IVolunteerTagModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.tag = Data["tag"];
      this.dateAdded = Data["dateAdded"];
    }
  }

  static fromJS(data: any): VolunteerTagModel {
    data = typeof data === 'object' ? data : {};
    let result = new VolunteerTagModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tag"] = this.tag;
    data["dateAdded"] = this.dateAdded;
    return data;
  }
}

export interface IVolunteerTagModel {
  tag?: string | undefined;
  dateAdded?: string | undefined;
}